import assets from 'shared/assets';
import styled, { css } from 'styled-components'

export const Des = styled.div`
  font-family: ${(props) => props.theme.fonts.alt};
  font-size: 0.75rem;
  text-transform: uppercase;
  width: 90%;
`

export const FilterTitle = styled.div`
  height: 80px;
  position: absolute;
  top: 80px;
  transform: rotate(90deg);
  font-family: ${(props) => props.theme.fonts.alt};
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
`;

export const Button = styled.div`
  width: 80px;
  height: 80px;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background: url(${assets.arrow}) no-repeat center center;
  background-size: 20px auto;
  transform: rotateY(180deg);
`

export const ExpandedContainer = styled.div`
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  padding: 4.5rem 1rem 3rem;
`

export const Cipher = styled.div`
  font-family: ${(props) => props.theme.fonts.alt};
  font-size: 4.5rem;
  color: black;
  font-weight: bolder;
`

const Wrapper = styled.div`
  width: 80px;
  height: 100%;
  position: fixed;
  top: 0;
  background: ${(props) => props.theme.colors.beige};
  right: 0;
  box-sizing: border-box;
  transition: all 0.5s ease;
  overflow-y: auto;

  ${(props) => props.active && css`
    width: 300px;

    ${Button}{
      transform: none!important;
    }
  `}

`

export default Wrapper;